var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('rect',{staticClass:"chartVisitBar",class:{ 'chartVisitBar--showStroke': _vm.showStroke },attrs:{"width":_vm.barWidth,"height":_vm.barHeight,"x":_vm.barX,"y":_vm.barY,"fill":_vm.fill},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}})
}
var staticRenderFns = []

export { render, staticRenderFns }